enum EBreadcrumb {
  ja,
  en,
  zh,
  vi,
  pt,
}

export const API_LANGUAGE_MAP = {
  en: "en_us",
  ja: "ja_jp",
  zh: "zh_cn",
  vi: "vi_vn",
  pt: "pt_pt",
};

export function getEnumByLocale(locale: string): number {
  return EBreadcrumb[(locale as keyof typeof EBreadcrumb) || "ja"];
}
